import "./Solutions.module.css";
import CabecalhoInstitucional from "@/reusable_sections/Header";
import SolucoesParaAmbientesCriticos from "./sections/SolucoesParaAmbientesCriticos";
import EspecialidadesPorSetor from "./sections/EspecialidadesPorSetor";
import NormasECertificacoes from "./sections/NormasECertificacoes";
import InformativeFooter from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <CabecalhoInstitucional />
      <SolucoesParaAmbientesCriticos />
      <EspecialidadesPorSetor />
      <NormasECertificacoes />
      <InformativeFooter />
    </div>;
}